export const SyncIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='text-[#021B84] dark:text-white'
  >
    <g clipPath='url(#clip0_5271_7392)'>
      <path d='M9.68036 10.7998L7.44043 13.0397L9.68036 15.2796' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M14.6902 7.48926C14.3782 10.6408 11.7274 13.0423 8.56036 13.0427H7.44043' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M11.3945 3.9508L14.4542 4.7706L15.2748 1.71094' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M6.02148 1.26787C8.90648 -0.0367914 12.3107 1.05834 13.8939 3.80041L14.4538 4.77101' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M4.60505 5.89072L3.78525 2.83105L0.725586 3.65085' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M4.96805 11.8859C2.39625 10.0387 1.64345 6.54274 3.22692 3.80068L3.78692 2.83008' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </g>
    <defs>
      <clipPath id='clip0_5271_7392'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
